import React from 'react'
import { connect } from 'react-redux'

import Modal from '../common/components/Modal'
import { showProfileInterestConfirmation } from "../completion/actions"

const ConfirmProfileInterest = props => props.show ? (
  <Modal
    heading="Thanks for your interest!"
    body="This feature is still in the works. We'll reach out as soon as it's ready."
    showSubmit={true}
    showCancel={false}
    buttonText='Okay'
    cancelText='close'
    buttonClick={props.closeConfirmation}
    cancelClick={props.closeConfirmation}
  />
) : (
  <span />
)

const mapStateToProps = state => ({
  show: state.completion.profileInterest.showConfirmation
})

const mapDispatchToProps = dispatch => ({
  closeConfirmation: () => dispatch(showProfileInterestConfirmation(false)),
})

const ProfileInterestModal = connect(mapStateToProps, mapDispatchToProps)(ConfirmProfileInterest)

export { ProfileInterestModal as default }


// WEBPACK FOOTER //
// ./assets/modals/ProfileInterestSuccessModal.js